import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Page } from 'src/components/matchbox';
import { PageLink } from 'src/components/links';

import Setup from './Setup';
import TypeSelection from './TypeSelection';
import { AlertFormContextProvider } from './useAlertForm';
import { AnalyticsReportContextProvider } from 'src/pages/analyticsReport/context/AnalyticsReportContext';
import { useRouteMatch } from 'react-router-dom';

const backBreadcrumb = { content: 'Alerts', to: '/alerts', as: PageLink };

export default function NewCreatePage() {
  const isDuplicatingAlert = useRouteMatch('/alerts/duplicate');
  const isEditingAlert = useRouteMatch('/alerts/new/edit/:alertId');

  const [shouldShowSetupForm, setShouldShowSetupForm] = useState(
    isDuplicatingAlert || isEditingAlert
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [shouldShowSetupForm]);

  const goToTypeSelection = useCallback(() => {
    setShouldShowSetupForm(false);
  }, []);

  const goToSetup = useCallback(() => {
    setShouldShowSetupForm(true);
  }, []);

  const pageTitle = useMemo(() => {
    if (isDuplicatingAlert) {
      return 'Duplicate Alert';
    }

    if (isEditingAlert) {
      return 'Edit Alert';
    }

    return 'Create Alert';
  }, [isDuplicatingAlert, isEditingAlert]);

  return (
    <Page title={pageTitle} breadcrumbAction={backBreadcrumb}>
      <AnalyticsReportContextProvider>
        <AlertFormContextProvider>
          {shouldShowSetupForm ? (
            <Setup goToTypeSelection={goToTypeSelection} />
          ) : (
            <TypeSelection goToSetup={goToSetup} />
          )}
        </AlertFormContextProvider>
      </AnalyticsReportContextProvider>
    </Page>
  );
}
